import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Create,
} from "adminApi/PaymentMethodApi/PaymentMethod";
import fields from "../json/PaymentMethodFeilds.json";
import { validateForm } from "utils/validation";
import { paymentMethodValidationRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddPaymentMethodForm from "./Componates/AddPaymentMethodForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddPaymentMethod = () => {      
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange} = useFormChange(initialValues, paymentMethodValidationRules);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Create({data:formData});
    },
    (vals) => validateForm(vals, paymentMethodValidationRules),
    () =>{ 
      return navigate(-1)
    },
    "Payment Method Created successfully"
  );
  return (
    <>
      {(loadingSubmit) && <Spinner isSpinner={true} />}
      <AddPaymentMethodForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Add Payment Method"
      />
    </>
  );
};

export default AddPaymentMethod;
